import { useMutation } from "@tanstack/vue-query";
import { baseApi } from "../baseApi";
import { useLazyQuery } from "../useLazyQuery";
import {
  type Order,
  type OrderType,
  type OrderCreateRequest,
  type OrderCreateResponse,
  type OrderListRequest,
  type OrderListResponse,
  type OrderLoadRequest,
  type OrderLoadResponse,
  type OrderAckRequest,
  type OrderAckResponse,
  type OrderStatusRequest,
  type OrderStatusResponse,
  type OrderActionListRequest,
  type OrderActionListResponse,
  type OrderActionDoneRequest,
  type OrderActionDoneResponse,
  type OrderHistoryResponse,
  type OrderHistoryRequest,
} from "./types";
import { ResponseCode } from "../types";

export const orderCreateApi = (body: OrderCreateRequest) =>
  baseApi<OrderCreateResponse, OrderCreateRequest>({ url: "/api/m/order/create", method: "POST", body });

export const orderListWidthCursorApi = async (order_type?: OrderType) => {
  let cursor = null;
  const orders: Order[] = [];

  do {
    const result = await orderListApi({ order_type: order_type || undefined, cursor: cursor || undefined });
    if (result.code !== ResponseCode.OK) return;

    cursor = result.cursor;

    orders.push(...result.orders);
  } while (cursor);

  return orders;
};
export const orderListApi = (body: OrderListRequest) =>
  baseApi<OrderListResponse, OrderListRequest>({ url: "/api/m/order/list", method: "POST", body });
export const useOrderList = () =>
  useLazyQuery<OrderListResponse, OrderListRequest>({
    queryKey: () => ["order-list"],
    queryFn: orderListApi,
    staleTime: 0,
  });

export const orderLoadApi = (body: OrderLoadRequest) =>
  baseApi<OrderLoadResponse, OrderLoadRequest>({ url: "/api/m/order/load", method: "POST", body });
export const useOrderLoad = () => useLazyQuery({ queryKey: () => ["order-load"], queryFn: orderLoadApi, staleTime: 0 });

export const orderAckApi = (body: OrderAckRequest) =>
  baseApi<OrderAckResponse, OrderAckRequest>({ url: "/api/m/order/ack", method: "POST", body });
export const useOrderAck = () => useMutation({ mutationFn: orderAckApi });

export const orderStatusApi = (body: OrderStatusRequest) =>
  baseApi<OrderStatusResponse, OrderStatusRequest>({ url: "/api/m/order/status", method: "POST", body });
export const useOrderStatus = () => useMutation({ mutationFn: orderStatusApi });

export const orderActionListApi = (body: OrderActionListRequest) =>
  baseApi<OrderActionListResponse, OrderActionListRequest>({ url: "/api/m/order/action_list", method: "POST", body });
export const useOrderActionList = () =>
  useLazyQuery<OrderActionListResponse, OrderActionListRequest>({
    queryKey: (params) => (params ? ["order-action-list", params.order_id] : ["order-action-list"]),
    queryFn: orderActionListApi,
    staleTime: 0,
  });

export const orderActionDoneApi = (body: OrderActionDoneRequest) =>
  baseApi<OrderActionDoneResponse, OrderActionDoneRequest>({ url: "/api/m/order/action_done", method: "POST", body });
export const useOrderActionDone = () => useMutation({ mutationFn: orderActionDoneApi });

export const orderHistoryWidthCursorApi = async () => {
  let cursor = null;
  const orders: Order[] = [];

  do {
    const result = await orderHistoryApi({ cursor: cursor || undefined });
    if (result.code !== ResponseCode.OK) return;

    cursor = result.cursor;

    orders.push(...result.orders);
  } while (cursor);

  return orders;
};
export const orderHistoryApi = (body?: OrderHistoryRequest) =>
  baseApi<OrderHistoryResponse, OrderHistoryRequest>({ url: "/api/m/order/history", method: "POST", body: body || {} });
export const useOrderHistory = () =>
  useLazyQuery<OrderHistoryResponse, OrderHistoryRequest>({
    queryKey: (params) => (params ? ["order-history", params.cursor] : ["order-history"]),
    queryFn: orderHistoryApi,
    staleTime: 0,
  });
